var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5, _rect5, _path6, _rect6, _path7, _rect7, _path8, _rect8, _path9, _rect9, _path10, _rect10, _path11, _rect11, _path12, _rect12, _rect13, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindmillOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 92,
    viewBox: "0 0 79 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4643 51H28.5357L27.4024 30.3571H23.5976L22.4643 51Z",
    fill: "#342E2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.21429,
    height: 10.9286,
    transform: "matrix(1 0 0 -1 24.9333 34.7286)",
    fill: "#342E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5357 0H22.4643L23.5976 20.6429H27.4024L28.5357 0Z",
    fill: "#342E2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.21429,
    height: 10.9286,
    transform: "matrix(-1 0 0 1 26.1072 15.7857)",
    fill: "#342E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5357L0 22.4643L20.6429 23.5976V27.4024L0 28.5357Z",
    fill: "#342E2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2714,
    y: 26.0667,
    width: 1.21429,
    height: 10.9286,
    transform: "rotate(-90 16.2714 26.0667)",
    fill: "#342E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 22.4643V28.5357L30.3571 27.4024V23.5976L51 22.4643Z",
    fill: "#342E2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2143,
    y: 24.8928,
    width: 1.21429,
    height: 10.9286,
    transform: "rotate(90 35.2143 24.8928)",
    fill: "#342E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0658 40.879L49.1015 35.621L30.6576 26.2811L28.7552 29.5761L46.0658 40.879Z",
    fill: "#342E2E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.21429,
    height: 10.9286,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 33.2089 30.605)",
    fill: "#342E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9342 10.121L1.89849 15.379L20.3424 24.719L22.2448 21.424L4.9342 10.121Z",
    fill: "#342E2E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.21429,
    height: 10.9286,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 17.3907 20.1171)",
    fill: "#342E2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9342 40.879L1.89849 35.621L20.3424 26.2811L22.2448 29.5761L4.9342 40.879Z",
    fill: "#342E2E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7911,
    y: 30.605,
    width: 1.21429,
    height: 10.9286,
    transform: "rotate(-120 17.7911 30.605)",
    fill: "#342E2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0658 10.121L49.1015 15.379L30.6576 24.719L28.7552 21.424L46.0658 10.121Z",
    fill: "#342E2E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6093,
    y: 20.1171,
    width: 1.21429,
    height: 10.9286,
    transform: "rotate(60 33.6093 20.1171)",
    fill: "#342E2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.621 49.1015L40.879 46.0658L29.5761 28.7552L26.2811 30.6576L35.621 49.1015Z",
    fill: "#342E2E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.21429,
    height: 10.9286,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 29.6235 33.7755)",
    fill: "#342E2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.379 1.8985L10.121 4.93421L21.4239 22.2448L24.7189 20.3424L15.379 1.8985Z",
    fill: "#342E2E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.21429,
    height: 10.9286,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 21.1686 16.7836)",
    fill: "#342E2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.379 49.1015L10.121 46.0658L21.4239 28.7552L24.7189 30.6576L15.379 49.1015Z",
    fill: "#342E2E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3764,
    y: 33.7755,
    width: 1.21429,
    height: 10.9286,
    transform: "rotate(-150 21.3764 33.7755)",
    fill: "#342E2E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.621 1.8985L40.879 4.93421L29.5761 22.2448L26.2811 20.3424L35.621 1.8985Z",
    fill: "#342E2E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8314,
    y: 16.7836,
    width: 1.21429,
    height: 10.9286,
    transform: "rotate(30 29.8314 16.7836)",
    fill: "#342E2E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 36,
    height: 1,
    fill: "#342E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20L79 18L75.5 24L79 30.5L59 29V20Z",
    fill: "#342E2E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 91.5V77M25.5 77L8.35822 89.7465C7.5921 90.3161 6.53957 89.5908 6.79921 88.672L12.5 68.5M25.5 77L38.5 68.5M25.5 77V59.5M25.5 77L12.5 68.5M12.5 68.5L43.5691 89.831C44.357 90.372 45.3822 89.6053 45.0859 88.6966L38.5 68.5M12.5 68.5L17.5 52.5M12.5 68.5L25.5 59.5M12.5 68.5H38.5M38.5 68.5L25.5 59.5M38.5 68.5L33.5 52.5M17.5 52.5L25.5 59.5M17.5 52.5L20.8455 41M17.5 52.5L30.1545 41M25.5 59.5L33.5 52.5M25.5 59.5V25M33.5 52.5L20.8455 41M33.5 52.5L30.1545 41M25.5 25L20.8455 41M25.5 25L30.1545 41",
    stroke: "#342E2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindmillOne);
export default __webpack_public_path__ + "static/media/windmill-one.6e134a5c.svg";
export { ForwardRef as ReactComponent };